import { isNil } from 'lodash';
import { PartnersBillingDetailsModelType } from './types';
import { PartnersBillingDetailsApi } from '@project/services';

export const PartnersBillingDetailsModel = (
  data?: PartnersBillingDetailsApi,
): PartnersBillingDetailsModelType => ({
  firstName: data?.first_name ?? '',
  lastName: data?.last_name ?? '',
  email: data?.email ?? '',
  mobile: data?.mobile ?? '',
  countryCode: data?.country_code ?? '',
  region: data?.region ?? '',
  city: data?.city ?? '',
  province: data?.province ?? '',
  street1: data?.street1 ?? '',
  street2: data?.street2 ?? '',
  zip: data?.zip ?? '',
});

export const SubscriptionModel = (data?: any): any => ({
  subscriptions: isNil(data?.event_subscriptions)
    ? []
    : data.event_subscriptions.map((subscription: any) => ({
        id: subscription.id,
        name: subscription.name,
        amount: subscription.amount,
        currency: subscription.currency,
        status: subscription.status,
      })),
});
